import React, {useContext} from 'react';
import TruncatedText from '@core/scripts/components/truncated-text';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import {Typography} from "@bonprix/design-system";

function AlpiInformation({
                             title,
                             fallback,
                             formerPrice,
                             formattedPrice,
                             uniquePrice,
                             reduction,
                             packItemsCount,
                             pricePerItem,
                             onAlpiInformationClick,
                         }) {
    const {texts, browser, abTextTooLong} = useContext(articleOverviewStaticContext);

    const renderAlpiTitle = () => {
        const oldBrowser = browser === 'IE';

        return (
            <div className="alpi__title" onClick={onAlpiInformationClick}>
                <TruncatedText className="alpi__truncated" oldBrowser={oldBrowser} lines={2}>
                    <Typography variant={"body1"} component="span" color="primary">{title}</Typography>
                </TruncatedText>
            </div>
        );
    }
    const renderAlpiPrice = () => {
        const reduced = reduction ? '-reduced' : '';
        const wordWrap = !uniquePrice && abTextTooLong ? '-word-wrap' : ''; // for countries with longer "ab" text (e.g. France): line break after formatted price
        const alpiPriceClasses = `alpi__price ${reduced} ${wordWrap}`;

        return (
            <section className="alpi__price-wrapper" onClick={onAlpiInformationClick}>
                <span className={alpiPriceClasses} test-ref__alpi-price="">
                    {uniquePrice ? <></> : <span className="alpi__price-ab-text">{texts.price_ab}</span>}
                    {formattedPrice}
                </span>

                {reduction ? (
                    <span className="alpi__reduction-wrapper">
                        <span className="alpi__formerprice">{formerPrice.formattedPrice}</span>
                        <span className="alpi__reduction">-{reduction}%</span>
                    </span>
                ) : (
                    <></>
                )}

                {packItemsCount > 1 &&
                    <p className="alpi__price-multipack-info">
                        <Typography variant={"body2"} component="span" color="on-bg-low">
                            {`${packItemsCount} ${texts.price_pack}`}
                        </Typography>
                        {pricePerItem && <>
                            <span className="alpi__price-multipack-separator">
                                <Typography variant={"body2"} component="span" color="on-bg-low">|</Typography>
                            </span>
                            <Typography variant={"body2"} component="span" color="on-bg-low">
                                {`${pricePerItem} ${texts.price_per_item}`}
                            </Typography>
                        </>}
                    </p>
                }

            </section>
        );
    };

    return (
        <div className="alpi__article-information">
            {renderAlpiTitle()}

            {fallback ? <></> : renderAlpiPrice()}
        </div>
    );


}

export default AlpiInformation;
